class Parameters {
    constructor(apiService = null) {
        this.obj_name = 'parameters';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // 處理選項
    getSelectOption(key, data, value) {
        console.log(`getSelectOption=`,data)
        const targetData = data.find((item) => item.id === key)?.options || [];
        let opList = []
        console.log()
        for (let index = 0; index < targetData.length; index++) {
            const item = targetData[index];
            if ( item.is_enable == 1 ){
                opList.push({
                    create_time: item.create_time,
                    id: item.id,
                    is_enable: item.is_enable,
                    name: item.name,
                    parameter_id: item.parameter_id,
                    weight: item.weight,
                    isSelect: true
                })
            } else {
                if ( item.id === value ){
                    opList.push({
                        create_time: item.create_time,
                        id: item.id,
                        is_enable: item.is_enable,
                        name: item.name,
                        parameter_id: item.parameter_id,
                        weight: item.weight,
                        isSelect: false
                    })
                }
            }
        }
        return opList
    }

    // API 方法
    // 參數 | 102 新增參數
    async addParameterOptions(parameter, progressEvent = null) {
        return this.callApi('post', 'addParameterOptions', parameter, progressEvent);
    }

    // 參數 | 103 更新參數狀態
    async updParameterOptions(parameter, progressEvent = null) {
        return this.callApi('post', 'updParameterOptions', parameter, progressEvent);
    }

    // 參數 | 104 取得參數列表
    async getParameterOptions(parameter) {
        return this.callApi('get', 'getParameterOptions', parameter);
    }
}

export default Parameters;
